import { Task } from '@admiin-com/ds-graphql';
import { WBFlex, WBTypography } from '@admiin-com/ds-web';
import { TaskDetailCard } from './components/TaskDetailCard';
import { TaskAmounts } from './components/TaskAmounts';
import { Divider } from '@mui/material';

export const TaskDetailMulti = ({
  tasks,
}: {
  tasks: Task[];
  onClose?: () => void;
}) => {
  return (
    <WBFlex flexDirection={'column'} gap={2} minWidth="300px">
      <WBFlex
        flexDirection={'row'}
        justifyContent={'space-between'}
        alignItems={'center'}
      >
        <WBFlex flexDirection="column" flex={1}>
          <WBTypography variant="h1" fontWeight={'700'}>
            {tasks.length} task{tasks.length === 1 ? '' : 's'} selected
          </WBTypography>
          <Divider />
        </WBFlex>
      </WBFlex>
      {tasks.map((task) => (
        <TaskDetailCard key={task.id} task={task} />
      ))}
      <TaskAmounts tasks={tasks} />
    </WBFlex>
  );
};
